import { render, staticRenderFns } from "./MapIndicatorLegend.vue?vue&type=template&id=1b96f759&scoped=true&"
import script from "./MapIndicatorLegend.vue?vue&type=script&lang=js&"
export * from "./MapIndicatorLegend.vue?vue&type=script&lang=js&"
import style0 from "./MapIndicatorLegend.vue?vue&type=style&index=0&id=1b96f759&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b96f759",
  null
  
)

export default component.exports